module.exports = __webpack_public_path__ + "static/media/family_insurance_medical.5d3561cb.svg";